var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275 112.67999",
    id: "svg107",
    sodipodiDocname: "logo-closer.svg",
    width: 563.22217,
    height: 112.67999,
    inkscapeVersion: "0.92.2 (5c3e80d, 2017-08-06)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1",
    id: "g105",
    style: {
      isolation: "isolate"
    },
    transform: "translate(-164.3,-232.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 200.3,305.9 a 16.26,16.26 0 0 0 -12.7,-6 c -8.3,0 -14.8,7.4 -14.8,15.6 0,9.1 6.3,15.7 15.4,15.7 5,0 9,-2.3 12.2,-5.9 v 11 a 24.63,24.63 0 0 1 -12.3,3 c -13.1,0 -23.8,-10.1 -23.8,-23.3 0,-13.7 10.6,-23.9 24.2,-23.9 a 23.43,23.43 0 0 1 11.7,3 v 10.8 z",
    id: "path8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 217.5,337.6 H 209 v -65.4 h 8.5 z",
    id: "path10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 272.3,315.6 a 23.7,23.7 0 1 1 -23.7,-23.7 23.29,23.29 0 0 1 23.7,23.7 z m -39,0 a 15.2,15.2 0 1 0 15.2,-15.5 15.45,15.45 0 0 0 -15.2,15.5 z",
    id: "path12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 297.1,303.4 a 6.45,6.45 0 0 0 -5.6,-3.9 4.6,4.6 0 0 0 -4.6,4.3 c 0,3.9 5.1,5.6 10.4,8 5.3,2.4 10.3,5.6 10.3,12.6 0,8.4 -7,14.7 -15.3,14.7 -6.4,0 -12.9,-3.7 -15.4,-10 l 7.3,-3.3 c 1.8,3.3 4,5.6 8.1,5.6 3.7,0 6.7,-2.4 6.7,-6.3 0,-2.3 -1.1,-3.5 -3.1,-4.9 l -8.3,-4.4 c -5,-2.7 -8.5,-5.1 -8.5,-11.2 a 13,13 0 0 1 13.1,-12.9 c 5.4,0 9.7,3 12.2,7.7 z",
    id: "path14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 319.8,316.9 c 0.1,7.6 5.2,14.7 13.4,14.7 6.5,0 10.1,-3.3 13.3,-8.6 l 7.2,4.1 a 23.29,23.29 0 0 1 -20.6,12.2 c -13.6,0 -21.8,-10.3 -21.8,-23.3 0,-13.6 7.3,-23.9 21.6,-23.9 14.3,0 20.8,10.4 20.8,23.7 v 1.3 h -33.9 z m 25.4,-6.5 c -1,-6.6 -5.4,-11.1 -12.3,-11.1 a 12.73,12.73 0 0 0 -12.6,11.1 z",
    id: "path16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 369.3,300.5 h 0.3 c 2.1,-5.2 6.4,-8.5 12.2,-8.5 a 13.45,13.45 0 0 1 7,2.2 l -3.9,7.7 a 7.51,7.51 0 0 0 -5.2,-1.8 c -9.2,0 -10.3,8.5 -10.3,15.7 v 21.8 h -8.5 v -44.4 h 8.5 z",
    id: "path18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 413.79,338.59 a 6.42,6.42 0 1 1 -6.41,-6.42 6.41,6.41 0 0 1 6.41,6.42 z",
    id: "path82",
    style: {
      mixBlendMode: "multiply",
      fill: "#00adee",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m 394.12,247.17 a 14.85,14.85 0 1 1 -14.84,-14.84 14.84,14.84 0 0 1 14.84,14.84 z",
    id: "path84",
    style: {
      mixBlendMode: "multiply",
      fill: "#652d90",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m 452.72,265 a 13.29,13.29 0 0 1 6.69,-5.41 19.24,19.24 0 0 0 -38.13,-1.1 26.85,26.85 0 0 1 31.44,6.51 z",
    id: "path86",
    style: {
      mixBlendMode: "multiply",
      fill: "#eb008b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M 451.69,277.05 A 19.22,19.22 0 0 1 421,261.58 a 19.74,19.74 0 0 1 0.27,-3.1 26.88,26.88 0 0 0 1.44,49.33 19,19 0 0 1 30.29,-7.42 26.74,26.74 0 0 0 6.48,-15.93 13.29,13.29 0 0 1 -7.79,-7.41 z",
    id: "path88",
    style: {
      mixBlendMode: "multiply",
      fill: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m 440.27,280.84 a 19.12,19.12 0 0 0 11.42,-3.79 13.17,13.17 0 0 1 1,-12.06 26.85,26.85 0 0 0 -31.44,-6.51 19.74,19.74 0 0 0 -0.27,3.1 19.27,19.27 0 0 0 19.29,19.26 z",
    id: "path90",
    style: {
      mixBlendMode: "multiply",
      fill: "#f1003a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m 432.64,309.71 a 26.82,26.82 0 0 1 -9.92,-1.9 19,19 0 1 0 30.28,-7.42 26.79,26.79 0 0 1 -20.36,9.32 z",
    id: "path92",
    style: {
      mixBlendMode: "multiply",
      fill: "#37b34a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m 422.72,307.81 a 26.85,26.85 0 0 0 30.28,-7.42 19,19 0 0 0 -30.26,7.42 z",
    id: "path94",
    style: {
      mixBlendMode: "multiply",
      fill: "#1f801e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m 463.92,258.78 a 13.2,13.2 0 0 0 -4.51,0.8 19.29,19.29 0 0 1 -2.52,11.67 26.76,26.76 0 0 1 2.62,11.58 c 0,0.55 0,1.09 -0.05,1.63 a 13.23,13.23 0 1 0 4.46,-25.68 z",
    id: "path96",
    style: {
      mixBlendMode: "multiply",
      fill: "#00adee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m 452.72,265 a 26.49,26.49 0 0 1 4.17,6.26 19.29,19.29 0 0 0 2.52,-11.67 13.29,13.29 0 0 0 -6.69,5.41 z",
    id: "path98",
    style: {
      mixBlendMode: "multiply",
      fill: "#2e008b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m 456.89,271.25 a 19.38,19.38 0 0 1 -5.2,5.8 13.29,13.29 0 0 0 7.77,7.41 c 0,-0.54 0.05,-1.08 0.05,-1.63 a 26.76,26.76 0 0 0 -2.62,-11.58 z",
    id: "path100",
    style: {
      mixBlendMode: "multiply",
      fill: "#1f801e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m 450.69,272 a 13.25,13.25 0 0 0 1,5 19.38,19.38 0 0 0 5.2,-5.8 26.49,26.49 0 0 0 -4.17,-6.26 13.13,13.13 0 0 0 -2.03,7.06 z",
    id: "path102",
    style: {
      mixBlendMode: "multiply",
      fill: "#210034"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d06449aaa6b381c38acb87adb706dcbd.svg";
export { ForwardRef as ReactComponent };